/**
 * issuer-ipa-events-api API
 * Manage events data
 *
 * The version of the OpenAPI document: 1.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * pool factory history
 */
export interface PoolFactorHistoryRequestDto { 
    instrumentId?: number;
    eventReference?: number;
    newPoolFactor?: number;
    oldPoolFactor?: number;
    creationDate?: string;
    partialRedmType?: string;
    comments?: string;
    isEventValidated?: boolean;
    updatedDateTime?: string;
}

